<template>
  <y-wrapper @back="goBack">
    <template slot="nav">
      <div class="navWrap">
        <div class="title-btns navTitle">
          <div class="btn">开班计划管理</div>
        </div>
      </div>
    </template>
    
    <template slot="main">
      <div class="dMain">
        <div class="searchWrap">
          <div class="selectWrap" style="width:500px">
            <select id="city" v-model="search.plan_level" @change="getRequest">
              <option value="">全部级别</option>
              <option
                v-for="(item, index) in quaLevelList"
                :key="index"
                :value="item.value"
              >
                {{ item.key }}
              </option>
            </select>
            <select v-model="search.year" @change="getRequest">
              <option value="">全部年份</option>
              <option v-for="(item) in yearList"
                :key="item.value"
                :value="item.value">{{ item.value }}年
              </option>
            </select>
            <select id="type" v-model="search.plan_type" @change="getRequest">
              <option value="">全部计划</option>
              <option value="month">月计划</option>
              <option value="year">年计划</option>
            </select>
          </div>
          <div class="search" style="width:250px">
            <div class="wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="search.keywords"
                @keyup.enter="getRequest"
                style="width:160px"
              />
              <div
                v-show="search.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="searchBtn" @click="getRequest">搜索</div>
          </div>
        </div>
        
        <div class="content-box">
          <yioks-loading v-show="isLoading"></yioks-loading>
          <template v-if="!isLoading && !pageList.length">
            <yioks-empty h="450px"></yioks-empty>
          </template>
          <template v-if="pageList.length">
            <div class="plane-list">
              <vue-scroll :ops="ops">
                <div class="scroll-content">
                  <div
                    class="plane-item"
                    v-for="(item, index) in pageList"
                    :key="index"
                  >
                    <div class="left">
                      <div class="">
                        {{ item.plan_name }}
                      </div>
                      <div class="title-2">
                        <span>截止时间：{{ item.plan_end_date | time(false) }}</span>
                        <span class="ml15">等级： {{ item.plan_level }}级</span>
                        <span class="ml15">计划开班数量： {{ item.classPlanOrgan || 0 }}个</span>
                      </div>
                    </div>
                    <div class="right">
                      <template>
                        <el-button
                          v-if="item.plan_status === 'Incomplete' && !item.classPlanOrgan"
                          type="primary"
                          size="mini"
                          @click="handleAddClassPlanOrgan(item)"
                        >添加开班计划
                        </el-button>
                        <el-button
                          v-if="item.plan_status === 'Incomplete' && item.classPlanOrgan > 0"
                          type="primary"
                          size="mini"
                          @click="handleAddClassPlanOrgan(item)"
                        >编辑开班计划
                        </el-button>
                        <el-button
                          v-if="item.classPlanOrgan > 0"
                          type="primary"
                          size="mini"
                          @click="handleViewClassPlan(item)"
                        >查看开班计划
                        </el-button>
                      </template>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
            <div id="paging">
              <yioks-paging
                :paging="paging"
                @goto-page="gotoPage($event)"
              ></yioks-paging>
            </div>
            <template v-if="isShowViewClassPlanInfo">
              <view-class-plan-info
                :isShowDialog.sync="isShowViewClassPlanInfo"
                :planId="plan_id"
                :planLevel="plan_level"
              ></view-class-plan-info>
            </template>
            <template v-if="showPlanOrganDialog">
            <addYearPlan :planInfo="planInfo" :canType="canType" :org_id="0" @hideTips="hideTips" :showdialog.sync="showPlanOrganDialog"></addYearPlan>
            </template>
          </template>
        </div>
      </div>
    </template>
  </y-wrapper>
</template>

<script>
  import {getClassPlanList} from "@/api/class_plan/api";
  import ops from "@/assets/js/vuescrollOption";
  
  export default {
    data(){
      const quaLevelList = [
        {key:"C级", value:"C"},
        {key:"D级", value:"D"},
      ];
      return {
        quaLevelList,
        ops:ops(),
        search:{
          plan_level:"",
          plan_type:"",
          keywords:"",
          year: new Date().getMonth() === 11 ? new Date().getFullYear() + 1 : new Date().getFullYear() ,
        },
        
        page:1,
        pageSize:20,
        isLoading:false,
        pageList:[],
        paging:{
          start:0, // 每页从第几条数据开始
          prePage:20, // 一页多少条数据
          total:0, // 总页数
          size:3, // 页码显示限制
          last:true, // 尾页
          next:true, // 下一页
          first:true, // 首页
          previous:true, // 上一页
          jump:true,
        },
        plan_id:"",
        plan_level:"",
        plan_type:"",
        isShowViewClassPlanInfo:false,
        showPlanOrganDialog:false,
        planInfo:{},
        canType:'add',
      };
    },
    
    filters:{
    },
    computed: {
      // 获取2019年至今的年份数组
      yearList(){
        let year = new Date().getMonth() === 11 ? new Date().getFullYear() + 1 : new Date().getFullYear();
        let yearList = [];
        for(var i = 0; i <= (year-2019); i++ ){
          yearList.push(
            {value:(2019+i), label:(2019+i)},
          );
        }
        return  yearList;
      }
    },
    components:{
      "v-icon":() => import("vue-awesome/components/Icon"),
      "yioks-empty":() => import("@/components/Tips/Empty"),
      "yioks-loading":() => import("@/components/Loading/Loading"),
      "yioks-paging":() => import("@/components/Pagination/Page"),
      "view-class-plan-info":() => import("@/components/ClassPlan/ViewClassPlanInfo"), // 查看会员协会开班计划
      "addYearPlan" :() => import('@/components/ClassPlan/addYearPlan')
    },
    
    created(){
      this.setSearch();
      this.loadPageList();
    },
    
    methods:{
      goBack(){
        this.$router.push({
          path: "training_course_list",
        });
      },
      getRequest(){
        this.changeQuery(true);
      },
      changeQuery(flag){
        if(flag){
          this.page = 1;
          this.pageList = [];
        }
        this.$router.replace({
          path:this.$route.path,
          query:{
            ...this.$route.query,
            ...this.search,
            page:this.page,
          },
        });
        this.loadPageList();
      },
      hideIcon(){
        this.$set(this.search, "keywords", "");
        this.getRequest();
      },
      setSearch() {
        const { plan_level, keywords, page, plan_type,year } = this.$route.query;
        plan_level && this.$set(this.search, "plan_level", plan_level);
        plan_type && this.$set(this.search, "plan_type", plan_type);
        keywords && this.$set(this.search, "keywords", keywords);
        year && this.$set(this.search, "year", year);
        page && (this.page = page);
      },
      loadPageList(){
        const {page, keywords, plan_level,plan_type} = this.$route.query;
        const queryData = {
          page:page || 1,
          keywords,
          plan_level,
          plan_type,
          year: this.search.year,
        };
        this.isLoading = true;
        getClassPlanList(queryData)
        .then(({data}) => {
          this.isLoading = false;
          if(data.status !== 0){
            this.$message.error(data.msg);
            return;
          }
          const {list, page} = data.result;
          this.pageList = list;
          this.paging = Object.assign({}, this.paging, {
            prePage:page.page_size,
            total:page.total_row,
            start:(this.page - 1) * this.paging.prePage,
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.error("err", err);
        });
      },
      // 添加编辑开班计划
      handleAddClassPlanOrgan(row){
        const {plan_id,plan_level,classPlanOrgan,plan_date,plan_type} = row;
        if(plan_type === 'year'){
          this.planInfo = row;
          this.showPlanOrganDialog=true;
          if(classPlanOrgan > 0){
            this.canType = "edit";
          }else{
            this.canType = "add";
          }
        }else{
          this.$router.push({
            path:"add_class_plan_organ",
            query:{
              plan_id:plan_id,
              plan_level:plan_level,
              plan_type:plan_type,
              classPlanOrgan:classPlanOrgan,
              plan_date:plan_date,
            },
          });
        }
        
      },
      
      // 查看开班计划详情
      handleViewClassPlan(row){
        const {plan_id,plan_level,plan_type} = row;
        if(plan_id){
          if(plan_type === 'year'){
            this.planInfo = row;
            this.showPlanOrganDialog=true;
            this.canType = "view";
          }else{
            this.plan_id = plan_id;
            this.plan_level = plan_level;
            this.plan_type = plan_type;
            this.isShowViewClassPlanInfo = true;
          }
        }
      },
      hideTips(bool){
        if (bool){
          this.showPlanOrganDialog=false;
          this.loadPageList();
        }
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  @import '~@/assets/css/defaultPage'
  .plane-list
    height 510px
    width 100%
    padding 15px 10px 10px
    font-size $font_size_medium
    
    .scroll-content
      margin 0 20px
      
      .plane-item
        border-bottom 1px solid #FFFFFF
        padding 10px 15px 10px
        margin 10px 10px 10px
        display flex
        justify-content space-between
        
        .right
          width 205px
          display flex
          align-items center
        
        .left
          display flex
          flex-direction column
          justify-content space-around
          
          .title-2
            color $color_info
            font-size $font_size_small
            margin-top 5px
  
  .mr10
    margin-right 10px
  
  .ml15
    margin-left 15px
</style>
